/**
 * Cart print button: triggers the browser print preview.
 */

export class CartPrintButtonElement extends HTMLElement {
  private boundClick = this.handleClick.bind(this)

  connectedCallback() {
    this.addEventListener('click', this.boundClick)
    this.addEventListener('keydown', this.handleKeydown)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClick)
    this.removeEventListener('keydown', this.handleKeydown)
  }

  private handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.handleClick(e)
    }
  }

  private handleClick(event: Event) {
    event.preventDefault()
    if (typeof window !== 'undefined') {
      window.print()
    }
  }
}
